import instantsearch from 'instantsearch.js/dist/instantsearch.production.min';
import {
    searchBox,
    hits,
    configure,
    refinementList,
    menuSelect,
    currentRefinements,
    clearRefinements,
    pagination,
    hitsPerPage,
    stats,
    index
} from 'instantsearch.js/es/widgets';
import {connectPagination} from 'instantsearch.js/es/connectors';
// import { helper } from 'instantsearch.js/es/helpers'

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

const SEARCH_ONLY = import.meta.env.VITE_TYPESENSE_SEARCH_ONLY_API_KEY || '';
const SEARCH_HOST = import.meta.env.VITE_TYPESENSE_HOST || '';
const SEARCH_PORT = import.meta.env.VITE_TYPESENSE_PORT || '';
const SEARCH_PROTOCOL = import.meta.env.VITE_TYPESENSE_PROTOCOL || '';
const indexName = import.meta.env.VITE_SEARCH_INDEX || '';
const eventIndexName = import.meta.env.VITE_SEARCH_EVENTS_INDEX || '';

const now = new Date();
const utcTimestamp = Math.floor(now.getTime() / 1000); // Adjust for UTC if needed

// const virtualSearchBox = connectSearchBox(() => null);
// console.log(import.meta.env);
// console.log(SEARCH_ONLY);
// console.log(SEARCH_HOST);
// console.log(indexName);
// console.log(eventIndexName);

// Create the render function
const renderPagination = (renderOptions, isFirstRender) => {
    const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
        widgetParams
    } = renderOptions;

    const { container } = widgetParams;

    if (nbPages <= 1) {
        container.style.display = 'none';
        return;
    } else {
        container.style.display = 'block';
    }

    const first = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`;
    const previous = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`;
    const next = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`;
    const last = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`;
    widgetParams.container.innerHTML = `
    <div class="query__pagination">
        <ul class="page-nav">
          ${
            !isFirstPage
                ? `
                <li>
                  <a
                    href="${createURL(0)}"
                    data-value="${0}"
                  >
                    ${first}
                  </a>
                </li>
                <li>
                  <a
                    href="${createURL(currentRefinement - 1)}"
                    data-value="${currentRefinement - 1}"
                  >
                    ${previous}
                  </a>
                </li>
                `
                : ''
        }
          ${pages
            .map(
                page => `
                <li ${currentRefinement === page ? 'class="current-page"' : ''}>
                  <a
                    href="${createURL(page)}"
                    data-value="${page}"
                  >
                    ${page + 1}
                  </a>
                </li>
              `
            )
            .join('')}
            ${
            !isLastPage
                ? `
                  <li>
                    <a
                      href="${createURL(currentRefinement + 1)}"
                      data-value="${currentRefinement + 1}"
                    >
                      ${next}
                    </a>
                  </li>
                  <li>
                    <a
                      href="${createURL(nbPages - 1)}"
                      data-value="${nbPages - 1}"
                    >
                      ${last}
                    </a>
                  </li>
                  `
                : ''
        }
        </ul>
    </div>
  `;

    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
        });
    });
};

// Create the custom widget
const customPagination = connectPagination(
    renderPagination
);






const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
        apiKey: SEARCH_ONLY, // Be sure to use the search-only-api-key
        nodes: [
            {
                host: SEARCH_HOST,
                port: SEARCH_PORT,
                protocol: SEARCH_PROTOCOL
            }
        ]
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  query_by is required.
    collectionSpecificSearchParameters: {
        [indexName]: {
            query_by: 'prioritizedSearchTerms,title,headline,summary,shortBio,personTitle',
        },
        [eventIndexName]: {
            query_by: 'title',
            sort_by: 'start_date_timestamp:asc'
        },
    },
});
const typesenseClient = typesenseInstantsearchAdapter.searchClient;

const searchClient = {
    ...typesenseClient,
    search(requests) {
        const requestId = Date.now(); // Unique ID for this batch
        console.log(`Search requests [${requestId}]:`, requests.map(req => ({
            indexName: req.indexName,
            query: req.params.query,
            page: req.params.page,
            results: req.nbHits
        })));
        if(requests.every(({ params }) => !params.query)) {
            return Promise.resolve({
                results: requests.map(() => ({
                    hits: [],
                    nbHits: 0,
                    nbPages: 0,
                    page: 0,
                    processingTimeMS: 0,
                    hitsPerPage: 0,
                    exhaustiveNbHits: false,
                    query: '',
                    params: '',
                })),
            });
        }

        return typesenseClient.search(requests);
    },
};
const renderWidget = {
    render({instantSearchInstance}) {
        const state = instantSearchInstance.renderState[indexName];
        const query = state?.searchBox?.query?.trim();

        const wrapper = document.getElementById('results-container');

        if (wrapper) {
            wrapper.style.display = query ? 'block' : 'none';
        }
    }
};
const eventsRenderWidget = {
    render({instantSearchInstance}) {
        const state = instantSearchInstance.renderState[eventIndexName];
        const results = state?.stats?.nbHits;
        const wrapper = document.getElementById('event-results-container');
        if (wrapper) {
            wrapper.style.display = results ? 'block' : 'none';
        }
        console.log(state);
        console.log(state?.stats?.nbHits)
    }
};

const search = instantsearch({
    searchClient,
    indexName: indexName,
    routing: true,
    future: {
        preserveSharedStateOnUnmount: true,
    },
});

search.addWidgets([
    searchBox({
        container: '#searchbox',
        placeholder: 'Search',
        searchAsYouType: false,
        showSubmit: false,
        cssClasses: {
            root: 'results__searchbar',
            form: 'results__search',
            input: 'results__input'
        },
    }),

    hitsPerPage({
        container: '#hits-per-page',
        items: [
            {label: 'Limit: 10', value: 10, default: true},
            {label: 'Limit: 20', value: 20},
            {label: 'Limit: 50', value: 50},
        ],
        cssClasses: {
            select: [
                'results__filter',
            ],
        },
    }),
    hits({
        container: '#hits',
        templates: {
            item(hit, {html, components}) {

                const externalImgCredit =
                    hit.externalImgCredit
                        ? html`<p class="news__photo-credit">${hit.externalImgCredit}</p>`
                        : '';
                const newsSourceLogo =
                    hit.newsSourceLogoSrc
                        ? html`<img src="${hit.newsSourceLogoSrc}" alt="caption goes here"
                                    class="external-source__img"/>`
                        : '';
                const nsTitle =
                    hit.newsSourceTitle
                        ? html`
                            <div class="news__external-source"><p
                                class="external-source__title${hit.newsSourceLogoSrc ? html` visually-hidden` : ''}">
                                ${hit.newsSourceTitle}</p></div>`
                        : '';
                const newsSource =
                    hit.newsSourceUrl
                        ? html`<a href="${hit.newsSourceUrl}" target="_blank"
                                  class="news__external-source">${newsSourceLogo}${nsTitle}</a>`
                        : html`${hit.newsSourceTitle ? nsTitle : ''}`;
                const imageSrc =
                    hit.imageSrc
                        ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url}"
                                  class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img
                            src="${hit.imageSrc}" srcset="${hit.imageSrcset}" alt="${hit.imageAltText}"
                            class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}"
                            sizes="(min-width:641px) 30vw, 100vw"/></a>`
                        : '';
                const previewImgSrc =
                    hit.previewImgSrc
                        ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url}"
                                  class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img
                            src="${hit.previewImgSrc}" srcset="${hit.previewImgSrcset}" alt="${hit.previewImgAltText}"
                            class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}"
                            sizes="(min-width:641px) 30vw, 100vw"/></a>`
                        : '';
                const externalImgSrc =
                    hit.externalImgSrc
                        ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url}"
                                  class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img
                            src="${hit.externalImgSrc}" srcset="${hit.externalImgSrcset}" alt="${hit.externalImgAltText}"
                            class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}"
                            sizes="(min-width:641px) 30vw, 100vw"/>${externalImgCredit}</a>`
                        : '';
                const headshotImgSrc =
                    hit.headshotImgSrc
                        ? hit.showLink === true ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url}"><img
                            src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}" alt="${hit.headshotAltTxt}"
                            class="people__image" sizes="(min-width:641px) 30vw, 100vw"/></a>` : html`
                            <div><img src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}"
                                      alt="${hit.headshotAltTxt}" class="people__image"
                                      sizes="(min-width:641px) 30vw, 100vw"/></div>`
                        : '';
                const parent = hit.parentUrl !== '' ? html`<p class="results__parent"><a href="${hit.parentUrl}"
                                                                                         class="results__link">${hit.parentTitle}</a>
                </p>` : '';
                const peopleBlock =
                    hit.handle === 'people'
                        ? html`
                            <div class="news__article-content">
                                ${headshotImgSrc ? headshotImgSrc : ''}
                                <div class="results__right">
                                    ${hit.showLink === true ? html`<a href="${hit.url}"
                                                                      class="results__entry-title">${components.Highlight({
                                        attribute: 'title',
                                        hit
                                    })}</a>` : html`<h3 class="results__entry-title">
                                        ${components.Highlight({attribute: 'title', hit})}</h3>`}
                                    ${hit.shortBio !== '' ? html`<p class="results__description">${components.Highlight({
                                        attribute: 'shortBio',
                                        hit
                                    })}</p>` : hit.personTitle !== '' ? html`<p class="results__description">
                                        ${components.Highlight({attribute: 'personTitle', hit})}</p>` : ''}
                                </div>
                            </div>`
                        : '';
                const contentBlock =
                    html`
                        ${newsSource}
                        <div class="news__article-content">

                            ${imageSrc ? imageSrc : previewImgSrc ? previewImgSrc : externalImgSrc ? externalImgSrc : headshotImgSrc ? headshotImgSrc : ''}

                            <div class="results__right">
                                ${hit.handle !== 'news' ? html`${parent}` : ''}
                                ${hit.handle === 'news'
                                    ? html`
                                        <div class="news__article-categories">
                                            ${hit.newsCategory?.map((cat) => html`<a href="${cat}"
                                                                                     class="news__article-category">${cat}</a> `)}
                                        </div>`
                                    : ''
                                }
                                <a href="${hit.externalUrl ? hit.externalUrl : hit.url}" class="results__entry-title">
                                    ${components.Highlight({attribute: 'title', hit})}
                                    ${hit.externalUrl || hit.externalLinkLS === true ? html`<i
                                        class="fa-regular fa-arrow-up-right-from-square external-link"></i>` : ''}
                                </a>
                                ${hit.summary !== ''
                                    ? html`<p class="results__description">
                                        ${components.Highlight({attribute: 'summary', hit})}</p>`
                                    : ''}
                            </div>
                        </div>
                    `;
                return html`
                    ${peopleBlock ? peopleBlock : contentBlock}
                `;
            },
            empty(results, {html}) {
                if (results.query === '') return null;
                return html`<h4>No results found for "${results.query}"</h4>`;
            },
        }
    }),
    pagination({
        container: '#pagination',
        cssClasses: {
            root: 'query__pagination',
            list: 'page-nav',
            selectedItem: 'current-page',
        },
        // templates: {
        //     first() {
        //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`
        //     },
        //     previous() {
        //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`
        //     },
        //     next() {
        //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`
        //     },
        //     last() {
        //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`
        //     },
        //
        // },
    }),
    customPagination({
        container: document.querySelector('#pagination'),
    }),
    stats({
        container: '#stats',
        templates: {
            text: ({
                       nbHits,
                       hasNoResults,
                       hasOneResult,
                       processingTimeMS,
                       query,
                   }) => {
                let statsText = '';
                if (hasNoResults) {
                    statsText = 'no results';
                } else if (hasOneResult) {
                    statsText = '1 result found';
                } else {
                    statsText = `${nbHits.toLocaleString()} results`;
                }
                return query !== ''
                    ? `Found ${statsText}.`
                    : ' ';
            },
        },
        cssClasses: {
            root: 'results__stats',
        },
    }),
    configure({
        hitsPerPage: 10
    }),
    renderWidget,
    index({indexName: eventIndexName}).addWidgets([
        configure({
            numericFilters: [`end_date_timestamp >= ${utcTimestamp}`],
            hitsPerPage: 5,
        }),
        hits({
            container: '#event-hits',
            templates: {
                item(hit, {html, components}) {

                    const eventDate = new Date(hit.start_date_timestamp * 1000);
                    let now = Date.now();
                    let isYGreater = formatUTCDateY(hit.start_date_timestamp, "UTC") > formatUTCDateNOWY(now, "UTC");
                    // const date = hit.start_date_timestamp * 1000;

                    // console.log(formatUTCDate(hit.start_date_timestamp, "UTC")); // "Sun, June 8 at 12:00 AM"
                    // console.log(formatDateWithMMDD(hit.start_date_timestamp, "UTC")); // "06.08"
                    // console.log(formatDateWithMMDD(hit.end_date_timestamp, "UTC")); // "06.08"
                    // console.log(formatDateWithDay(hit.start_date_timestamp, "UTC")); // "Sun"
                    // console.log(formatUTCDateYmd(hit.start_date_timestamp, "UTC")); // "Y-m-d"
                    // console.log(formatDateWithMM(hit.start_date_timestamp, "UTC")); // "MM"
                    // console.log(hit.allDay);
                    //
                    //
                    // console.log(formatDateWithMM(hit.start_date_timestamp, "UTC") !== formatDateWithMM(hit.end_date_timestamp, "UTC"));
                    // console.log(formatDateWithMM(hit.start_date_timestamp, "UTC"));
                    // console.log(formatDateWithMM(hit.end_date_timestamp, "UTC"));
                    // console.log(formatDateWithMM(hit.start_date_timestamp, "UTC") === formatDateWithMM(hit.end_date_timestamp, "UTC"));
                    // console.log(formatUTCDateTime(hit.start_date_timestamp, "UTC").replace(/\s+[AP]M/i, ''));
                    // console.log(formatUTCDateTime(hit.end_date_timestamp, "UTC"));
                    // console.log(eventDate > now);
                    // console.log(formatUTCDateY(hit.start_date_timestamp, "UTC") > formatUTCDateNOWY(now, "UTC"));
                    console.log(hit.allDay);
                    console.log(hit.multiDay);
                    const multiDayWk =
                        formatDateWithMM(hit.start_date_timestamp, "UTC") === formatDateWithMM(hit.end_date_timestamp, "UTC")
                            ? html`<span
                                class="calendar__row-week">${formatDateWithDay(hit.start_date_timestamp, "UTC")}
                                –${formatDateWithDay(hit.end_date_timestamp, "UTC")}</span>`
                            : '';
                    const multiDayRow = html`<span
                                class="calendar__row-date">${formatDateWithMMDD(hit.start_date_timestamp, "UTC")}–
                                ${formatDateWithMM(hit.start_date_timestamp, "UTC") !== formatDateWithMM(hit.end_date_timestamp, "UTC") ? formatDateWithMMDD(hit.end_date_timestamp, "UTC") : formatDateWithDD(hit.end_date_timestamp, "UTC")}</span>`;

                    const rowDate = html`<span class="calendar__row-date">${formatDateWithMMDD(hit.start_date_timestamp, "UTC")}</span>`;
                    const rowWk = html`<span class="calendar__row-week">${formatDateWithDay(hit.start_date_timestamp, "UTC")}</span>`;
                    const rowY = html`<p class="calendar__event__meta-year">${formatUTCDateY(hit.start_date_timestamp, "UTC")}</p>`;

                    const timeDuration = html`<p class="calendar__event__meta-time">
                        ${formatUTCDateTime(hit.start_date_timestamp, "UTC").replace(/\s+[AP]M/i, '')}
                            –${formatUTCDateTime(hit.end_date_timestamp, "UTC")}</p>`;

                    const canceled = hit.isCanceled === true ? html`CANCELLED: ` : '';

                    const image = html`<a class="calendar__event-hero-img"
                                          href="${hit.url || '#'}" ${hit.externalUrl === true ? html`target="_blank"` : ''}>
                        <img src="${hit.imageSrc}"
                             srcset="${hit.imageSrcset}"
                             sizes="(min-width:641px) 25vw, 50vw" alt="${hit.imageAltText ? hit.imageAltText : hit.imageCaption ? hit.imageCaption : hit.imageTitle}"
                             class="calendar__event-image"/>
                    </a>`;


                    // if (eventDate > now) {
                        return html`
                            <div class="calendar__row" data-date="${formatUTCDateYmd(hit.start_date_timestamp, "UTC")}">
                                <div class="calendar__row-left">
                                    <h2 class="calendar__date-wrapper">
                                        ${hit.allDay ? rowDate : hit.multiDay ? multiDayRow : rowDate }
                                        ${hit.allDay ? rowWk : hit.multiDay ? multiDayWk : rowWk }
                                    </h2>
                                </div>
                                <div class="calendar__row-right">
                                    <div id="calendar__event" class="calendar__event" data-event-index="0">
                                        <div class="calendar__event__meta">
                                            <div class="calendar__event__meta-wrapper">
                                                <div class="calendar__event__meta-title">
                                                    <p>
                                                        <a href="${hit.url || '#'}"
                                                           ${hit.externalUrl === true ? html`target="_blank"` : ''}>
                                                            ${canceled}${components.Highlight({attribute: 'title', hit})}
                                                        </a>
                                                    </p>
                                                </div>
                                                ${hit.allDay ? '' : hit.multiDay ? timeDuration : timeDuration}
                                                ${hit.isRepeating && isYGreater ? rowY : ''}
                                            </div>
                                            <!-- image goes here -->
                                            ${hit.imageSrc ? image : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    // } else {
                    //     return null;
                    // }
                },
                empty: (results, {html}) => {
                    console.log(results);
                    console.log(results.nbHits);
                    // console.log(results.hits|length === 0 ? 'true' : 'false');
                    // const eventDate = new Date(hit.start_date_timestamp * 1000);
                    // let now = Date.now();
                    // console.log(results);
                    // console.log(results.hits.length);
                    // console.log(document.querySelector('.event-search-results__wrapper'));
                    // document.querySelector('.event-search-results__wrapper').classList.add('empty');

                    // console.log(eventDate < now);
                    if (results.query === '') return null;
                    return html`<h4>No events found for "${results.query}"</h4>`;

                },
            },
        }),
        stats({
            container: '#event-stats',
            templates: {
                text: ({
                           nbHits,
                           hasNoResults,
                           hasOneResult,
                           processingTimeMS,
                           query,
                       }) => {
                    let statsText = '';
                    if (hasNoResults) {
                        statsText = 'no results';
                    } else if (hasOneResult) {
                        statsText = '1 result found';
                    } else {
                        statsText = `${nbHits.toLocaleString()} results`;
                    }
                    return query !== ''
                        ? `Found ${statsText}.`
                        : ' ';
                },
            },
            cssClasses: {
                root: 'results__stats',
            },
        }),
        eventsRenderWidget,
        pagination({
            container: '#event-pagination',
            cssClasses: {
                root: 'query__pagination',
                list: 'page-nav',
                selectedItem: 'current-page',
            },
            // templates: {
            //     first() {
            //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`
            //     },
            //     previous() {
            //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`
            //     },
            //     next() {
            //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`
            //     },
            //     last() {
            //         return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`
            //     },
            //
            // },
        }),
        customPagination({
            container: document.querySelector('#event-pagination'),
        })
    ]),
]);


search.start();

const searchFormInput = document.querySelector('.ais-SearchBox-input');
const searchReset = document.querySelector('.ais-SearchBox-reset');
const searchSuggestions = document.querySelector('#search-suggestions');
const searchResults = document.querySelector('#results-container');
// Get query from URL, e.g., ?q=your+search+term
const params = new URLSearchParams(window.location.search);
const initialQuery = params.get('q') || params.get(indexName + '[query]') || '';

console.log(params);
console.log(initialQuery);

if (initialQuery) {
    search.setUiState({
        [indexName]: {
            query: initialQuery,
            page: 1,
        },
        [eventIndexName]: {
            query: initialQuery,
            page: 1,
        },
    });

    searchSuggestions.style.display = 'none';

}




let searchQuery = '';
searchFormInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
        searchQuery = e.target.value;
        console.log(searchQuery);
        if (searchQuery) {
            searchSuggestions.style.display = 'none';
        }
    }
});


searchReset.addEventListener('click', () => {
    console.log('Before reset:', search.getUiState());
    searchSuggestions.style.display = 'block';
    searchQuery = '';
    searchFormInput.value = '';

    search.setUiState({
        [indexName]: {
            query: '',
            refinementList: {},
            page: 1,
        },
        [eventIndexName]: {
            query: '',
            refinementList: {},
            page: 1,
        },
    });

    search.helper.setQuery('').search();
    // search.refresh();

    console.log('After reset:', search.getUiState());
    // console.log('SearchBox query:', search.renderState[indexName].searchBox?.query);
});



function formatUTCDate(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        weekday: 'short',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: timezone // Use 'America/New_York' for EDT
    };
    return date.toLocaleString('en-US', options).replace(/, (\d+),/, ', $1 at');
}
function formatUTCDateYmd(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: timezone // Use 'America/New_York' for EDT
    };
    const [month, day, year] = date.toLocaleString('en-US', options).split(/[\/]/);
    return `${year}-${month}-${day}`;
}
function formatUTCDateY(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        year: 'numeric',
        timeZone: timezone // Use 'America/New_York' for EDT
    };
    const [year] = date.toLocaleString('en-US', options).split(/[\/]/);
    return `${year}`;
}
function formatUTCDateNOWY(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp);
    const options = {
        year: 'numeric',
        timeZone: timezone // Use 'America/New_York' for EDT
    };
    const [year] = date.toLocaleString('en-US', options).split(/[\/]/);
    return `${year}`;
}
function formatDateWithMMDD(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        month: '2-digit',
        day: '2-digit',
        timeZone: timezone
    };
    const [month, day] = date.toLocaleString('en-US', options).split(/[\/, ]+/);
    return `${month}.${day}`;
}
function formatDateWithMM(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        month: '2-digit',
        timeZone: timezone
    };
    const [month] = date.toLocaleString('en-US', options).split(/[\/]+/);
    return `${month}`;
}
function formatDateWithDD(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        day: '2-digit',
        timeZone: timezone
    };
    const [day] = date.toLocaleString('en-US', options).split(/[\/]+/);
    return `${day}`;
}
function formatDateWithDay(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        weekday: 'short',
        timeZone: timezone
    };
    const [day] = date.toLocaleString('en-US', options).split(/[\/]+/);
    return `${day}`;
}
function formatUTCDateTime(timestamp, timezone = 'UTC') {
    const date = new Date(timestamp * 1000);
    const options = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: timezone // Use 'America/New_York' for EDT
    };
    return date.toLocaleString('en-US', options);
}
